import { S as p } from "./chunk-SwiperElement-lRkrDvjn.js";
import { t as l } from "./chunk-custom-element-CN0MC8o7.js";
import "./chunk-lit-element-D3OkYgeM.js";
var u = Object.getOwnPropertyDescriptor, d = (e, t, a, r) => {
  for (var i = r > 1 ? void 0 : r ? u(t, a) : t, s = e.length - 1, n; s >= 0; s--)
    (n = e[s]) && (i = n(i) || i);
  return i;
};
let o = class extends p {
  constructor() {
    super(...arguments), this.swiperOptions = {
      on: {
        afterInit: (e) => {
          this.updateNavigationVisibility(e), window.addEventListener("resize", this.debouncedResize(e));
        }
      }
    }, this.debouncedResize = (e) => {
      let t;
      return () => {
        clearTimeout(t), t = setTimeout(() => {
          this.updateNavigationVisibility(e);
        }, 200);
      };
    };
  }
  updateNavigationVisibility(e) {
    setTimeout(() => {
      const t = e.navigation.nextEl, a = e.navigation.prevEl, r = t == null ? void 0 : t.parentElement;
      if (t && a && r) {
        const i = t.getAttribute("aria-disabled") === "true", s = a.getAttribute("aria-disabled") === "true";
        r.style.display = i && s ? "none" : "";
      }
    }, 100);
  }
};
o = d([
  l("swiper-with-nav")
], o);
export {
  o as SwiperWithNav
};
